import React from 'react';

const FormField = ({ 
  label, 
  id, 
  type = 'text', 
  value, 
  onChange, 
  required = false,
  placeholder = '',
  autoFocus = false,
  options = [],
  infoTooltip = null
}) => {
  const renderInput = () => {
    switch (type) {
      case 'text':
      case 'number':
      case 'email':
        return (
          <input
            type={type}
            id={id}
            value={value}
            onChange={onChange}
            required={required}
            placeholder={placeholder}
            autoFocus={autoFocus}
            className="form-input"
          />
        );
      case 'textarea':
        return (
          <textarea
            id={id}
            value={value}
            onChange={onChange}
            required={required}
            placeholder={placeholder}
            className="form-textarea"
          />
        );
      case 'radio':
        return (
          <div className="radio-group">
            {options.map(option => (
              <div key={option.value} className="radio-option">
                <input
                  type="radio"
                  id={`${id}-${option.value}`}
                  name={id}
                  value={option.value}
                  checked={value === option.value}
                  onChange={() => onChange({ target: { value: option.value } })}
                  required={required}
                />
                <label htmlFor={`${id}-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        );
      case 'checkbox':
        return (
          <div className="checkbox-group">
            {options.map(option => (
              <div key={option.value} className="checkbox-option">
                <input
                  type="checkbox"
                  id={`${id}-${option.value}`}
                  name={`${id}-${option.value}`}
                  value={option.value}
                  checked={Array.isArray(value) ? value.includes(option.value) : value === option.value}
                  onChange={(e) => {
                    if (Array.isArray(value)) {
                      // Para múltiples checkboxes
                      const newValue = e.target.checked
                        ? [...value, option.value]
                        : value.filter(val => val !== option.value);
                      onChange({ target: { value: newValue } });
                    } else {
                      // Para un solo checkbox
                      onChange(e);
                    }
                  }}
                />
                <label htmlFor={`${id}-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        );
      default:
        return <input type="text" id={id} value={value} onChange={onChange} />;
    }
  };

  return (
    <div className="form-group">
      <label htmlFor={id}>
        {label}
        {required && <span className="required-mark">*</span>}
        {infoTooltip && (
          <span className="info-icon" title={infoTooltip}>ℹ️</span>
        )}
      </label>
      <div className="input-container">
        {renderInput()}
      </div>
    </div>
  );
};

export default FormField;